
const digest = '65846fe48c8537ce76a659f21a4727c29aae9ee8fc7b02ad4eba296f815d62a8';
const classes = {"wrapper":"_wrapper_1gz74_1","title":"_title_1gz74_17","chevron":"_chevron_1gz74_23","count":"_count_1gz74_31"};
const css = `._wrapper_1gz74_1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: 6px;
  background-color: #f1f3f8;
  font-size: 13px;
  font-weight: 600;
  user-select: none;
}
._wrapper_1gz74_1:hover {
  cursor: pointer;
  background-color: #e8ebf5;
}

._title_1gz74_17 {
  display: flex;
  align-items: center;
  gap: 8px;
}

._chevron_1gz74_23 {
  width: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
}

._count_1gz74_31 {
  font-weight: 600;
  opacity: 0.7;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  